import { render, staticRenderFns } from "./SectionWhyUs.vue?vue&type=template&id=4db6fab1&"
import script from "./SectionWhyUs.vue?vue&type=script&lang=js&"
export * from "./SectionWhyUs.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhyUs.vue?vue&type=style&index=0&id=4db6fab1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomText: require('/app/components/atoms/common/AtomText.vue').default})
